var map = {
	"./Bell.svg": "KTCR",
	"./Calendar.svg": "h/1k",
	"./Cloud_computing.svg": "yX3o",
	"./File.svg": "zQRa",
	"./Stars.svg": "YuGM",
	"./View.svg": "rv/Y",
	"./View_y.svg": "5+Zr",
	"./Yen.svg": "4rDY",
	"./icon_hanghaochaxun.svg": "Ab8z",
	"./icon_jisuanqi.svg": "dUtM",
	"./icon_s.svg": "F05x",
	"./icon_scqtpm.svg": "qdi6",
	"./icon_shuaxin.svg": "Iyu7",
	"./icon_t.svg": "3y87",
	"./iphone1.svg": "H2eZ",
	"./rzline-Call_Center.svg": "x+gR",
	"./rzline-description.svg": "/LzY",
	"./rzline-headset.svg": "kbpI",
	"./rzline-hyzx.svg": "tval",
	"./upload.svg": "P/TB",
	"./weixin.svg": "E+Kt",
	"./word_yuan.svg": "HKFM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 70